<template>
    <div>
        <!-- 标题 -->
        <center-title>欄目尚未開放使用</center-title>
    </div>
</template>

<script>
export default {
    components: {
        centerTitle: () => import("@/components/center/centerTitle"),
    },
}
</script>

<style scoped>

</style>